import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3010/';

const axiosServices = axios.create({
  baseURL,
  // ❌ don’t force global Content-Type
  // headers: { 'Content-Type': 'application/json' }
});

// ✅ Intercept requests: set Content-Type dynamically
axiosServices.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('serviceToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // 👉 If FormData, let the browser set boundary automatically
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    } else {
      // Default JSON header
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 🔁 Handle 401 or network issues
axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ERR_NETWORK') {
      return Promise.reject({
        message: 'Internal Server Error',
        status: false
      });
    }

    if (error.response?.status === 401 && !window.location.href.includes('/login')) {
      window.location.pathname = '/login';
    }

    return Promise.reject(error.response?.data || 'Unknown error');
  }
);

// For SWR or general fetching
export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.get(url, { ...config });
  return res.data;
};

export default axiosServices;
